import BrandLogo from '@/assets/branding/4ward/4ward.png';

const colors = {
  // Brand colors
  brand_primary: '#6b479f',
  brand_primary_hover: '#553E75', // -10 L, -8 S
  brand_primary_highlight: '#A789D2', // +23 L, +7 S
  brand_primary_mid: '#7F57B8', // +8 L,  +2 S
  brand_primary_dark: '#302145', // -25 L, -3 S
  brand_secondary: '#4C3960', // hue +4 deg, -15 L, -13 S
  brand_accent_start: '#7F57B8',
  brand_accent_end: '#778FD5',
  brand_accent_light_start: '#ECE5F5',
  brand_accent_light_end: '#ECF1FE',
  brand_complementary_accent: 'rgb(149,207,63)',
  brand_auth_gradient_mid: '#4C3960',
  brand_auth_gradient_end: '#302145',
  brand_auth_warp_mid: '#7F57B8',
};

export default {
  name: '4Ward Innovation',
  isSAML: true,
  allowPersonalCourses: false,
  logo: BrandLogo,
  colors,
};
